module.exports = __webpack_public_path__ + "static/media/datazip-logo.7f60a4e0.svg";